import { FC } from 'react';

import HistoryMovementsViewExpandedTableHeader from './HistoryMovementsViewExpandedTableHeader';
import HistoryMovementsViewExpandedTableBody from './HistoryMovementsViewExpandedTableBody';

const HistoryMovementsViewExpandedTable: FC = () => (
  <table className="table" id="expanded-table">
    <HistoryMovementsViewExpandedTableHeader />
    <HistoryMovementsViewExpandedTableBody />
  </table>
);

export default HistoryMovementsViewExpandedTable;
